import React from 'react';
import { useRouterContext } from '../contexts/RouterProvider';
import { SORT_OPTIONS, defaultSortLabel, parseListingSort, withListingSort } from '../utils/listing-sort';

/**
 * Sort order for the listings below it: Best match, newest or oldest first,
 * price low to high or high to low.
 *
 * It only writes `?sortBy=` to the URL. The browse and search pages already
 * read every URL param into the search they run, so the URL change is what
 * refetches, and a sorted page survives reload, back and sharing.
 *
 * In showcase view each row's listings follow the sort; the rows keep their
 * ranked order.
 */
const SearchSortSelect: React.FC = () => {
  const { asPath, query, replace } = useRouterContext();
  const current = parseListingSort(query.sortBy) ?? '';

  // The view stays as it is: showcase rows keep the sort inside each row.
  const onChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    replace(withListingSort(asPath, parseListingSort(e.target.value)), { shallow: true });
  };

  return (
    <label className="search-sort-select">
      <select value={current} onChange={onChange} aria-label="Sort by" data-testid="search-sort-select">
        {SORT_OPTIONS.map(({ value, label }) => (
          <option key={value || 'best'} value={value}>
            {value === '' ? defaultSortLabel(query.q ?? query.keywords) : label}
          </option>
        ))}
      </select>
    </label>
  );
};

export default SearchSortSelect;
